import { db } from './firebase.js';
import { doc, getDoc } from 'firebase/firestore';

export const fetchLeaderboardData = async () => {
  const snap = await getDoc(doc(db, 'leaderboard', 'latest'));
  if (!snap.exists()) throw new Error('leaderboard/latest not found');
  return snap.data();
};
